import { SvgIcon } from '@material-ui/core'

export const MonitorIcon = props => (
  <SvgIcon {...props} style={{ fill: 'none' }}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      viewBox="0 0 28 28"
      fill="none"
    >
      <path
        d="M17.5 19.8333V24.5H10.5V19.8333M6.06667 19.8333H21.9333C23.2401 19.8333 23.8935 19.8333 24.3926 19.579C24.8317 19.3553 25.1886 18.9984 25.4123 18.5593C25.6667 18.0602 25.6667 17.4068 25.6667 16.1V7.23333C25.6667 5.92654 25.6667 5.27315 25.4123 4.77402C25.1886 4.33498 24.8317 3.97802 24.3926 3.75432C23.8935 3.5 23.2401 3.5 21.9333 3.5H6.06667C4.75988 3.5 4.10648 3.5 3.60735 3.75432C3.16831 3.97802 2.81135 4.33498 2.58765 4.77402C2.33333 5.27315 2.33333 5.92654 2.33333 7.23333V16.1C2.33333 17.4068 2.33333 18.0602 2.58765 18.5593C2.81135 18.9984 3.16831 19.3553 3.60735 19.579C4.10648 19.8333 4.75988 19.8333 6.06667 19.8333Z"
        stroke="#667085"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </SvgIcon>
)
